<template>
  <LayoutPC v-if="isMobile === 'PC'" />
  <LayoutH5 v-if="isMobile === 'MOBILE'" />
</template>

<script setup>
import LayoutPC from './components/LayoutPC/index.vue'
import LayoutH5 from './components/LayoutH5/index.vue'
import { useCouponDialog } from '@/components/Login/hooks/useCouponDialog.js'
import { useGoogleOneTap } from '@/hooks/useGoogleOneTap'
import { useSearchUrl } from '@/hooks/useSearchUrl'
import { useCartStore } from '@/pinia/cart'
import { useLanguage } from './hooks/useLanguage'
import { useCurrencyStore } from '@/pinia/currency'
import { useCountryStore } from '@/pinia/country'
import { useUserStore } from '@/pinia/user'

const cartStore = useCartStore()
const { init: initSearchUrl } = useSearchUrl()
const user = useUserStore()
const { initLanguage } = useLanguage()
const { init: initCurrency } = useCurrencyStore()
const { init: initCountry } = useCountryStore()

useCouponDialog()
useGoogleOneTap()

const isMobile = ref(false)
onBeforeMount(() => {
  initLanguage()
  initSearchUrl()
  initCurrency()
  initCountry()
  if (user.isLogged) {
    user.initUserInfo()
  }
  cartStore.updateCartCount()

  const userAgent = navigator.userAgent.toLowerCase()
  isMobile.value = /iphone|ipod|ipad|android|blackberry|windows phone/i.test(userAgent) ? 'MOBILE' : 'PC'
})
</script>
